import ApiCall from "utils/ApiCall";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getPrearrivalsBooking = async (query?: string, bookingFilter?: any) => {
  try {
    const route = `${process.env.REACT_APP_API}/prearrivals/bookings${
      query || ""
    }`;
    // console.log("calling to api:", route)
    const bookings = await ApiCall.get(route);

    return bookings || [];
  } catch (err) {
    throw err;
  }
};

const getPrearrivalsRecord = async (query?: string) => {
  try {
    const route = `${process.env.REACT_APP_API}/prearrivals/records${
      query || ""
    }`;
    // console.log("calling to api:", route)
    return await ApiCall.get(route);
    // return await ApiCall.get(`${process.env.REACT_APP_API}/prearrivals?email=peterchan@email.com`);
  } catch (err) {
    console.error("getPrearrivalsRecord err:", err);
    throw err;
  }
};

const sendPreArrivalNotificationEmail = async (data: any) => {
  // console.log(JSON.stringify(data))
  return await ApiCall.post(
    `${process.env.REACT_APP_API}/prearrivals/email`,
    data
  );
};

const createPrearrival = async (data: any) => {
  return await ApiCall.post(
    `${process.env.REACT_APP_API}/prearrivals/records`,
    { ...data, bookingNumber: data?.bookingNumber || data?.confirmationNumber }
  );
};

const deletePrearrival = async (id: number) => {
  return await ApiCall.delete(
    `${process.env.REACT_APP_API}/prearrivals/records/${id}`
  );
};

export {
  getPrearrivalsRecord,
  getPrearrivalsBooking,
  sendPreArrivalNotificationEmail,
  createPrearrival,
  deletePrearrival,
};
